/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BillableServiceKeyfigureControllerService } from './services/billable-service-keyfigure-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BillableServiceKeyfigureControllerService,
    ApiConfiguration
  ],
})
export class BillableServiceKeyfigureModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BillableServiceKeyfigureModule> {
    return {
      ngModule: BillableServiceKeyfigureModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BillableServiceKeyfigureModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BillableServiceKeyfigureModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
